import {
    Avatar,
    Box,
    Button,
    Chip,
    Divider,
    Icon,
    IconButton,
    Menu,
    MenuItem,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SaleDto } from "../../../api/psc";
import { ConfirmationDialog } from "../../../components/exports";
import { SaleStatusConstants } from "../../../constants/SaleConstants";
import { DialogContext } from "../../../contexts/DialogueContext";
import { UserContext } from "../../../contexts/UserContext";
import { deleteSaleThunk } from "../../../slices/SalesSlice";
import { RootState } from "../../../slices/Store";
import { toJalaliDate } from "../../../utils/date";
import AddSaleActivityDialog from "../dialogs/AddSaleActivityDialog";
import UpdateSaleDialog from "../dialogs/UpdateSaleDialog";
import SaleActivityItem from "./SaleActivityItem";

export default function ProjectDetailSaleItem(props: { sale: SaleDto }) {
    const user = useContext(UserContext);

    const dispatch = useDispatch();
    const saleState = useSelector((state: RootState) => state.salesState);

    const isCreatorOrOwner = props.sale.user.id === user.id || user.role === 1;

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const sale = props.sale;

    const { openDialog } = useContext(DialogContext);

    const statusConstant = SaleStatusConstants.find(
        (s) => s.id === sale.status
    );

    const handleEditDialog = () => {
        openDialog(<UpdateSaleDialog sale={sale} />);
    };

    const handleDeleteSale = () => {
        openDialog(
            <ConfirmationDialog
                title="مایل به حذف این فرایند فروش هستید؟"
                onAccept={async () => {
                    await deleteSaleThunk(props.sale.id, saleState, dispatch);
                }}
            />
        );
    };

    const openAddActivityDialog = () => {
        openDialog(<AddSaleActivityDialog saleId={sale.id} />);
    };

    const openMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    return (
        <Paper sx={{ p: 1.5 }}>
            <Stack divider={<Divider />} spacing={1.5}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Avatar
                        src={sale.user.avatarUrl}
                        sx={{ width: 40, height: 40 }}
                    />
                    <Stack flexGrow={1}>
                        <Typography color="primary" sx={{ flexGrow: 1 }}>
                            {sale.user.displayName}
                        </Typography>
                        <Typography
                            color="text.secondary"
                            fontSize="small"
                            sx={{ flexGrow: 1 }}
                        >
                            {toJalaliDate(sale.createDate)}
                        </Typography>
                    </Stack>

                    <Chip size="small" label={statusConstant.title} />

                    <IconButton onClick={openMenu}>
                        <Icon>more_vert</Icon>
                    </IconButton>

                    <Menu anchorEl={anchorEl} open={open} onClose={closeMenu}>
                        <MenuItem
                            onClick={handleEditDialog}
                            disabled={!isCreatorOrOwner}
                        >
                            ویرایش
                        </MenuItem>
                        <Divider />
                        <MenuItem
                            onClick={handleDeleteSale}
                            disabled={!isCreatorOrOwner}
                        >
                            حذف
                        </MenuItem>
                    </Menu>
                </Box>

                {sale.description && (
                    <Typography sx={{ whiteSpace: "pre-wrap" }}>
                        {sale.description}
                    </Typography>
                )}

                {sale.activities.map((a) => {
                    return (
                        <SaleActivityItem
                            key={a.id}
                            saleId={sale.id}
                            activity={a}
                        />
                    );
                })}

                <Button
                    variant="text"
                    color="secondary"
                    size="small"
                    startIcon={<Icon>add</Icon>}
                    onClick={openAddActivityDialog}
                >
                    افزودن فعالیت
                </Button>
            </Stack>
        </Paper>
    );
}
